import * as React from 'react';
import { Position, OverlayToaster, Toaster as BPToaster } from '@blueprintjs/core';
import './styles.scss';
import { uniqueId } from 'lodash';
import Toast, { IToastProps } from '../Toast';
import {createRoot} from "react-dom/client";

export interface IToastData {
    intent: IToastProps["intent"];
    text: IToastProps["text"];
    timeout?: number;
    asHtml?: boolean;
}

class Toaster {
    private static toasterInstance: Promise<BPToaster> | null = null;

    static getToasterInstance(): Promise<BPToaster> {
        if (!this.toasterInstance) {
            this.toasterInstance = OverlayToaster.createAsync({
                    position: Position.TOP,
                    autoFocus: false,
                },
                {
                    domRenderer: (toaster, containerElement) => createRoot(containerElement).render(toaster),
                }
            );
        }
        return this.toasterInstance;
    }

    static addToast(toastProps: IToastData): void {
        const toastKey = uniqueId();
        this.getToasterInstance().then((toaster) => {
            toaster.show({
                message: <Toast {...toastProps} toastKey={toastKey} />,
                timeout: toastProps.timeout ? toastProps.timeout : 3000,
            });
        });
    }
}

export default Toaster;
